import ImageGallery from "./components/ImageGallery/ImageGallery";

function App() {
  return (
    <div>
      <ImageGallery />
    </div>
  );
}

export default App;
